import React, { Component } from 'react';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import Dropdown from 'react-dropdown'
import {LFO_COLORS} from './lfo-colors.js';
import LFOSyncedTimes from 'components/lfo/LFOSyncedTimes.js';
import LFOShapeDropdown from 'components/lfo/LFOShapeDropdown.js';

import '../../Instruments.scss';

class LFOComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedLFO: 0,
        };
    }

    getLFOOptions() {
        let options = [
            {value: 0, label:'LFO 1'},
            {value: 1, label:'LFO 2'},
            {value: 2, label:'LFO 3'},
            {value: 3, label:'LFO 4'},
        ];

        return options;
    }

    getLFOOption(value) {
        let options = this.getLFOOptions();
        for (var i=0; i < options.length; i++) {
            if (options[i].value == value) {
                return options[i];
            }
        }
        return null;
    }

    onSelectLFO(lfo) {
        this.setState({
            selectedLFO: lfo.value
        });
    }

    onChangeSynced(synced) {
        this.getLFO().isSynced = synced === 'unsynced';
        this.setState(this.state);
    }

    getLFO() {
        return this.props.instrument.lfos[this.state.selectedLFO];
    }

    render() {
        let lfo = this.getLFO();
        return (
            <div className="instrument-subsection">
              <div className={"instrument-subsection-name lfo-subsection-name colored-lfo-name-" + this.state.selectedLFO}>
                LFO 
              </div>
              <div className="osc-type-dropdown-container">
                <Dropdown
                  className='osc-type-dropdown'
                  controlClassName='osc-type-control-dropdown'
                  arrowClassName='osc-type-arrow-dropdown'
                  options={this.getLFOOptions()}
                  onChange={(o) => this.onSelectLFO(o)}
                  value={this.getLFOOption(this.state.selectedLFO)}
                  placeholder="LFO" />
              </div>
              <div className="clear-fix"/>
              <LFOShapeDropdown lfo={lfo}/>
              <div className="clear-fix"/>
              <div className="refined-checkbox-preferences">
                      <label>
                        <input 
                          type="checkbox"
                          value={lfo.isSynced ? "synced" : "unsynced"}
                          checked={lfo.isSynced}
                          onChange={(e) => this.onChangeSynced(e.target.value)} />
                          Synced
                      </label>
                    </div>
              {lfo.isSynced ? <LFOSyncedTimes lfo={lfo}/> :
              <EffectParameterSlider
                effectNumber={0}
                name={'Rate'}
                parameter={lfo.lfoRateParameter}
                  onParameterChanged={() => []}
                  isParameter={true}
                  step={0.1}
                  min={0}
                  max={32}
                />}
                <EffectParameterSlider
                  effectNumber={0}
                  name={'Min'}
                  parameter={lfo.lfoMinParameter}
                  onParameterChanged={() => []}
                  isParameter={true}
                  min={-100}
                  max={100}
                  step={1}
                  />
                <EffectParameterSlider
                  effectNumber={0}
                  name={'Max'}
                  parameter={lfo.lfoMaxParameter}
                  onParameterChanged={() => []}
                  isParameter={true}
                  min={-100}
                  max={100}
                  step={1}
                  />
        </div>
        );
    }
}

export default LFOComponent;
